import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Facebook from "../../assets/logo/facebook.svg";
import Instagram from "../../assets/logo/instagram.svg";
import Linkedin from "../../assets/logo/linkedin.svg";
import Youtube from "../../assets/logo/youtube.svg";
import LogoKA from "../../assets/logo/logo-krause-assistencial-branco.png";
import LogoKrause from "../../assets/logo/logo-grupo-krause-branco.png";
import "./Footer.css";

export default function Footer(props) {
  return (
    <div className="footer-div">
      <div className="ganhadores-first-divider" />
      <Container fluid className="footer-container">
        <Container>
          <Row>
            <Col className="footer-logos-col">
              <a
                href="https://grupokrause.com.br/servicos/krause-assistencial/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={LogoKA} alt="Logo KA" className="footer-logo" />
              </a>
              <a
                href="https://www.grupokrause.com.br/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={LogoKrause}
                  alt="Logo Grupo Krause"
                  className="footer-logo"
                />
              </a>
            </Col>
          </Row>
          <Row>
            <div className="footer-icon-links">
              <a
                href="https://www.facebook.com/grupokrauseoficial/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={Facebook}
                  alt="icone facebook"
                  className="footer-social-links"
                />
              </a>
              <a
                href="https://www.instagram.com/grupokrause/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={Instagram}
                  alt="icone instagram"
                  className="footer-social-links"
                />
              </a>
              <a
                href="https://br.linkedin.com/company/grupokrause"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={Linkedin}
                  alt="icone Linkedin"
                  className="footer-social-links"
                />
              </a>
              <a
                href="https://www.youtube.com/channel/UCe25r6x82-9ASERj8IkU-vw"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={Youtube}
                  alt="icone youtube"
                  className="footer-social-links"
                />
              </a>
            </div>
          </Row>
          <Row className="footer-contact-row">
            <Col md={4} className="footer-contact-col">
              <a
                href={`https://wa.me/${props.whatsAppNumber}?text=Gostaria%20de%20saber%20mais%20sobre%20a%20Vida%20Premiada%20Krause.`}
                rel="noopener noreferrer"
                className="footer-contact-link"
              >
                <p>WhatsApp</p> <span>51 9414 1188</span>
              </a>
            </Col>
            <Col md={4} className="footer-contact-col">
              <a
                href="tel:05130369660"
                rel="noopener noreferrer"
                className="footer-contact-link"
              >
                <p>Atendimento 24h</p>
                <span>51 3036 9660</span>
              </a>
            </Col>
            <Col md={4} className="footer-contact-col">
              <a
                href="tel:08000029600"
                rel="noopener noreferrer"
                className="footer-contact-link"
              >
                <p>Atendimento Funerário 24h</p>
                <span>0800 002 9600</span>
              </a>
            </Col>
          </Row>
          <Row>
            <Col className="footer-rights-col">
              <p>© 2026 Grupo Krause - Todos os direitos reservados.</p>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}
